import axios from 'axios'
import { Cookies } from 'react-cookie'
const cookie = new Cookies()
const token = cookie.get('token')
// const isDev = process.env.NODE_ENV === 'development'
export const domain = process.env.REACT_APP_DOMAIN_NAME
// export const domain = 'avinvas.com'
export const baseUrl = `https://${process.env.REACT_APP_API_DOMAIN}`
let options = {
  baseURL: `${baseUrl}/api/`,
  headers: {},
}
if (token) {
  options.headers['Authorization'] = `Bearer ${token}`
}
const instance = axios.create(options)
// instance.defaults.headers['x-platform'] = 0;
instance.defaults.headers['Content-Type'] = 'application/json'
// axios.defaults.timeout = 30000;
// axios.defaults.httpsAgent = new https.Agent({ keepAlive: true });

// instance.interceptors.request.use(
//   function (config) {
//     // Do something before request is sent
//     return config
//   },
//   function (error) {
//     // Do something with request error
//     console.log('request error')
//     return Promise.reject(error)
//   },
// )

// axios.interceptors.request.use(
//   function (config) {
//     // Do something before request is sent
//     return config
//   },
//   function (error) {
//     // Do something with request error
//     return Promise.reject(error)
//   },
// )

instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    console.log(error.response.status)
    if (error.response.status === 401) {
      cookie.remove('token', {
        path: '/',
      })
      window.location.href = '/login'
    }
    console.log(error)
    return Promise.reject(error)
  },
)

export default instance
